import type { RouteObject } from 'react-router-dom'

import { Component } from '@/modules/login/pages/Login'
import { LoginRoutePathsEnum } from '@/modules/login/routes/loginRouteConfig.types'

export const LOGIN_ROUTES: RouteObject[] = [
  {
    element: <Component />,
    path: LoginRoutePathsEnum.LOGIN,
  },
]
